
export type UILanguage = 'ar' | 'fr' | 'en' | 'ber' | 'es';

export const translations: Record<UILanguage, any> = {
  fr: {
    heroTitle: "Donnez vie à la langue",
    heroSubtitle: "amazighe",
    heroDesc: "ⵜⵉⵏⴼⵓⵙⵉⵏ ⵏ ⵉⵎⵥⵥⵢⴰⵏⵏ transforme vos idées en contes illustrés écrits en Tifinaghe. Un pont entre tradition et futur technologique.",
    startBtn: "Commencer l'Aventure",
    cultureTag: "IA au service de la culture",
    featuresTitle: "Tout ce que vous pouvez faire",
    showcaseTitle: "Contes de la communauté",
    showcaseDesc: "Explorez les dernières aventures imaginées par nos utilisateurs.",
    readOnlyTitle: "Mode Lecture",
    feat1Title: "IA Amazighe",
    feat1Desc: "Générez des histoires uniques en Tifinaghe grâce à l'intelligence artificielle.",
    feat2Title: "Illustrations",
    feat2Desc: "Chaque page est accompagnée d'un dessin magique généré pour votre conte.",
    feat3Title: "Lecture Audio",
    feat3Desc: "Écoutez vos histoires avec une voix naturelle pour apprendre la prononciation.",
    feat4Title: "Export PDF",
    feat4Desc: "Transformez vos créations en livres numériques à imprimer ou partager.",
    loginTitle: "Content de vous revoir !",
    signupTitle: "Créer votre compte",
    authDesc: "",
    email: "Email",
    password: "Mot de passe",
    name: "Nom complet",
    loginBtn: "Se connecter",
    signupBtn: "S'inscrire",
    noAccount: "Pas encore de compte ? S'inscrire",
    hasAccount: "Déjà un compte ? Se connecter",
    library: "Bibliothèque",
    explore: "Explorer",
    searchPlaceholder: "Rechercher par titre ou contenu (Tifinaghe)...",
    noResults: "Aucun conte ne correspond à votre recherche.",
    prev: "Précédent",
    next: "Suivant",
    profile: "Profil",
    logout: "Se déconnecter",
    saveProfile: "Sauvegarder les changements",
    newStory: "Nouvelle Aventure",
    newStoryDesc: "Transformez vos rêves en contes amazighs.",
    storyPromptPlaceholder: "Un petit hérisson qui découvre les montagnes de l'Atlas...",
    genBtn: "Générer l'Histoire",
    pages: "Pages",
    lang: "Langue de saisie",
    thinking: "Imagination du conte...",
    painting: "Création des illustrations...",
    quotaError: "La génération de contes est actuellement indisponible. Veuillez réessayer ultérieurement.",
    emptyLib: "Votre bibliothèque est vide.",
    createFirst: "Créer ma première histoire",
    back: "Retour",
    share: "Partager",
    download: "Télécharger PDF",
    downloadAudio: "Télécharger l'audio",
    close: "Fermer",
    copy: "Copié",
    vocabulary: "Vocabulaire Magique",
    audioError: "L'API de synthèse vocale ne répond pas. Veuillez réessayer."
  },
  ar: {
    heroTitle: "أعد الحياة إلى اللغة",
    heroSubtitle: "الأمازيغية",
    heroDesc: "ⵜⵉⵏⴼⵓⵙⵉⵏ ⵏ ⵉⵎⵥⵥⵢⴰⵏⵏ يحول أفكارك إلى حكايات مصورة مكتوبة بالتيفيناغ. جسر بين التقاليد ومستقبل التكنولوجيا.",
    startBtn: "ابدأ المغامرة",
    showcaseTitle: "قصص المجتمع",
    showcaseDesc: "استكشف أحدث المغامرات التي تخيلها مستخدمونا.",
    readOnlyTitle: "وضع القراءة",
    cultureTag: "الذكاء الاصطناعي في خدمة الثقافة",
    featuresTitle: "كل ما يمكنك القيام به",
    feat1Title: "ذكاء اصطناعي أمازيغي",
    feat1Desc: "أنشئ قصصًا فريدة بالتيفيناغ بفضل الذكاء الاصطناعي.",
    feat2Title: "رسومات توضيحية",
    feat2Desc: "كل صفحة مصحوبة برسم سحري يتم إنشاؤه لقصتك.",
    feat3Title: "قراءة صوتية",
    feat3Desc: "استمع إلى قصصك بصوت طبيعي لتعلم النطق.",
    feat4Title: "تصدير PDF",
    feat4Desc: "حول إبداعاتك إلى كتب رقمية للطباعة أو المشاركة.",
    loginTitle: "سعيد برؤيتك مرة أخرى!",
    signupTitle: "أنشئ حسابك",
    authDesc: "",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    loginBtn: "تسجيل الدخول",
    signupBtn: "إنشاء حساب",
    noAccount: "ليس لديك حساب؟ سجل الآن",
    hasAccount: "لديك حساب بالفعل؟ سجل الدخول",
    library: "المكتبة",
    explore: "استكشاف",
    searchPlaceholder: "ابحث عن طريق العنوان أو المحتوى...",
    noResults: "لا توجد قصص تطابق بحثك.",
    prev: "السابق",
    next: "التالي",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
    saveProfile: "حفظ التغييرات",
    newStory: "مغامرة جديدة",
    newStoryDesc: "حول أحلامك إلى قصص أمازيغية.",
    storyPromptPlaceholder: "قنفذ صغير يكتشف جبال الأطلس...",
    genBtn: "إنشاء القصة",
    pages: "صفحات",
    lang: "لغة الإدخال",
    thinking: "تخيل القصة...",
    painting: "إنشاء الرسومات...",
    quotaError: "الخدمة مشغولة جداً الآن. حاول مجدداً بعد دقيقة.",
    emptyLib: "مكتبتك فارغة.",
    createFirst: "أنشئ قصتي الأولى",
    back: "رجوع",
    share: "مشاركة",
    download: "تحميل PDF",
    downloadAudio: "تحميل الصوت",
    close: "إغلاق",
    copy: "تم النسخ",
    vocabulary: "المفردات السحرية",
    audioError: "خدمة الصوت لا تعمل حالياً."
  },
  en: {
    heroTitle: "Bring Life to the",
    heroSubtitle: "Amazigh Language",
    heroDesc: "ⵜⵉⵏⴼⵓⵙⵉⵏ ⵏ ⵉⵎⵥⵥⵢⴰⵏⵏ transforms your ideas into illustrated stories written in Tifinagh. A bridge between tradition and the technological future.",
    startBtn: "Start the Adventure",
    showcaseTitle: "Community Stories",
    showcaseDesc: "Explore the latest adventures imagined by our users.",
    readOnlyTitle: "Read Only Mode",
    cultureTag: "AI serving culture",
    featuresTitle: "Everything You Can Do",
    feat1Title: "Amazigh AI",
    feat1Desc: "Generate unique stories in Tifinagh using artificial intelligence.",
    feat2Title: "Illustrations",
    feat2Desc: "Every page is accompanied by a magical drawing generated for your tale.",
    feat3Title: "Audio Reading",
    feat3Desc: "Listen to your stories with a natural voice to learn pronunciation.",
    feat4Title: "PDF Export",
    feat4Desc: "Turn your creations into digital books to print or share.",
    loginTitle: "Welcome Back!",
    signupTitle: "Create Your Account",
    authDesc: "",
    email: "Email",
    password: "Password",
    name: "Full Name",
    loginBtn: "Login",
    signupBtn: "Sign Up",
    noAccount: "Don't have an account? Sign up",
    hasAccount: "Already have an account? Login",
    library: "Library",
    explore: "Explore",
    searchPlaceholder: "Search by title or content...",
    noResults: "No stories match your search.",
    prev: "Previous",
    next: "Next",
    profile: "Profile",
    logout: "Logout",
    saveProfile: "Save Changes",
    newStory: "New Adventure",
    newStoryDesc: "Transform your dreams into Amazigh tales.",
    storyPromptPlaceholder: "A little hedgehog discovering the Atlas mountains...",
    genBtn: "Generate Story",
    pages: "Pages",
    lang: "Input Language",
    thinking: "Imagining the story...",
    painting: "Creating illustrations...",
    quotaError: "API is very busy right now. The stars are sleeping... Try again in a minute!",
    emptyLib: "Your library is empty.",
    createFirst: "Create my first story",
    back: "Back",
    share: "Share",
    download: "Download PDF",
    downloadAudio: "Download Audio",
    close: "Close",
    copy: "Copied",
    vocabulary: "Magic Vocabulary",
    audioError: "Speech service unavailable."
  },
  ber: {
    heroTitle: "ⵙⵙⵉⴷⵔ ⵜⵓⵜⵍⴰⵢⵜ",
    heroSubtitle: "ⵜⴰⵎⴰⵣⵉⵖⵜ",
    heroDesc: "ⵜⵉⵏⴼⵓⵙⵉⵏ ⵏ ⵉⵎⵥⵥⵢⴰⵏⵏ ⴰⵔ ⵉⵜⵜⴰⵔⵔⴰ ⵜⵉⵡⵏⴳⵉⵎⵉⵏ ⵏⵏⴽ ⴷ ⵜⵉⵏⴼⴰⵙ ⵙ ⵜⵉⴼⵉⵏⴰⵖ. ⵢⴰⵏ ⵓⵎⴰⴳⵔⴰⴷ ⵏ ⵜⵓⵙⵙⵏⴰ ⴷ ⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ.",
    startBtn: "ⵙⵙⵏⵜⵉ ⵜⴰⴳⵓⵔⵉ",
    showcaseTitle: "ⵜⵉⵏⴼⴰⵙ ⵏ ⵜⴳⵔⴰⵡⵜ",
    showcaseDesc: "ⵣⵔ ⵜⵉⴳⵓⵔⵉⵡⵉⵏ ⵜⵉⵎⴰⵢⵏⵓⵜⵉⵏ ⵏ ⵉⵎⵙⵙⵓⴷⵓⵔⵏ ⵏⵏⵖ.",
    readOnlyTitle: "ⵜⵉⵖⵔⵉ ⵖⴰⵙ",
    cultureTag: "ⵜⴰⵎⵓⵙⵏⵉ ⵜⴰⵎⵙⵙⵓⵔⵜ ⵉ ⵜⵓⵙⵙⵏⴰ",
    featuresTitle: "ⵎⴰⵢⴷ ⵜⵣⵎⵔⴷ ⴰⴷ ⵜⴳⴷ",
    feat1Title: "ⵜⴰⵎⵓⵙⵏⵉ ⵜⴰⵎⴰⵣⵉⵖⵜ",
    feat1Desc: "ⵙⵙⵓⴼⵓⵖ ⵜⵉⵏⴼⴰⵙ ⵙ ⵜⵉⴼⵉⵏⴰⵖ ⵙ ⵜⵎⵓⵙⵏⵉ ⵜⴰⵎⵙⵙⵓⵔⵜ.",
    feat2Title: "ⵜⵉⵡⵍⴰⴼⵉⵏ",
    feat2Desc: "ⴽⵓ ⵜⴰⵙⵏⴰ ⵜⴷⴷⴰ ⴷ ⵢⴰⵜ ⵜⵡⵍⴰⴼⵜ ⵜⴰⵙⴼⵔⴰⵔⵜ.",
    feat3Title: "ⵜⵉⵖⵔⵉ ⵙ ⵓⵎⵙⵍⵉ",
    feat3Desc: "ⵙⵙⴼⵍⴷ ⵉ ⵜⵉⵏⴼⴰⵙ ⵏⵏⴽ ⵙ ⵓⵎⵙⵍⵉ ⴰⴳⴰⵎⴰⵏ.",
    feat4Title: "PDF",
    feat4Desc: "ⵙⵙⵓⴼⵓⵖ ⵜⵉⵏⴼⴰⵙ ⵏⵏⴽ ⵙ ⵓⴼⴰⵢⵍⵓ PDF.",
    loginTitle: "ⴰⵏⵙⵓⴼ ⵢⵉⵙⴽ!",
    signupTitle: "ⴳ ⴰⵎⵉⴹⴰⵏ ⵏⵏⴽ",
    authDesc: "",
    email: "ⵉⵎⴰⵢⵍ",
    password: "ⵜⴰⴳⵓⵔⵉ ⵏ ⵓⴽⵛⵛⵓⵎ",
    name: "ⵉⵙⵎ ⵓⴽⵎⵉⵍ",
    loginBtn: "ⴽⵛⵛⵎ",
    signupBtn: "ⴳ ⴰⵎⵉⴹⴰⵏ",
    noAccount: "ⵓⵔ ⵜⵍⵉⴷ ⴰⵎⵉⴹⴰⵏ? ⴳ ⴰⵎⵉⴹⴰⵏ",
    hasAccount: "ⵜⵍⵉⴷ ⴰⵎⵉⴹⴰⵏ? ⴽⵛⵛⵎ",
    library: "ⵜⴰⵙⴷⵍⵉⵙⵜ",
    explore: "ⴰⵔⵣⵣⵓ",
    searchPlaceholder: "ⵔⵣⵣⵓ ⵙ ⵡⴰⵙⵙⴰⵖ ⵏⵖ ⵜⵉⵏⴼⵓⵙⵜ...",
    noResults: "ⵓⵔ ⵜⵍⵍⵉ ⵜⵏⴼⵓⵙⵜ ⵏⵏⴰ ⵜⵔⵣⵣⵓⴷ.",
    prev: "ⴰⵎⵣⵡⴰⵔⵓ",
    next: "ⴰⵎⴰⵢⵏⵓ",
    profile: "ⴰⵎⵉⴹⴰⵏ",
    logout: "ⴼⴼⵓⵖ",
    saveProfile: "ⵃⵣⵣⵓ ⵉⴱⴷⴷⵉⵍⵏ",
    newStory: "ⵜⴰⴳⵓⵔⵉ ⵜⴰⵎⴰⵢⵏⵓⵜ",
    newStoryDesc: "ⵙⵙⵉⴷⵔ ⵜⵉⵡⴰⵔⴳⵉⵡⵉⵏ ⵏⵏⴽ ⵙ ⵜⵎⴰⵣⵉⵖⵜ.",
    storyPromptPlaceholder: "ⵢⴰⵏ ⵓⴱⵓⴼⵜⵉⵍ ⵉⵙⵙⵏ ⵉⴷⵔⴰⵔⵏ ⵏ ⵡⴰⵟⵍⴰⵚ...",
    genBtn: "ⵙⵙⵓⴼⵓⵖ ⵜⴰⵏⴼⵓⵙⵜ",
    pages: "ⵜⵉⵙⵏⵉⵡⵉⵏ",
    lang: "ⵜⵓⵜⵍⴰⵢⵜ",
    thinking: "ⴰⵔ ⵉⵜⵜⵅⵎⵎⴰⵎ...",
    painting: "ⴰⵔ ⵉⵙⵡⵍⴰⴼ...",
    quotaError: "ⵜⴰⵎⵓⵙⵏⵉ ⵜⴰⵎⵙⵙⵓⵔⵜ ⵜⵔⵎⵎⵢ. ⴰⵖⵓⵍ ⴷ ⵢⴰⵜ ⵜⵓⵙⴷⵉⴷⵜ.",
    emptyLib: "ⵜⴰⵙⴷلⵉⵙⵜ ⵜﺨⵡⴰ.",
    createFirst: "ⵙⵙⵏⵜⵉ ⵜⴰⵏⴼⵓⵙⵜ ⵉⵏⵓ ⵜⴰⵎⵣⵡⴰⵔⵓⵜ",
    back: "ⴰⵖⵓⵍ",
    share: "ⴱⴹⵓ",
    download: "ⵙⵙⵓⴼⵓⵖ PDF",
    downloadAudio: "ⵙⵙⵓⴼⵓⵖ ⴰⵎⵙⵍⵉ",
    close: "ⵎⴷⵍ",
    copy: "ⵢⵓⵎⵢ",
    vocabulary: "ⵜⴰⴳⵔⵓⵎⵎⴰ ⵏ ⵜⴳⵓⵔⵉⵡⵉⵏ",
    audioError: "ⴰⵎⵙⵍⵉ ⵓⵔ ⵉⵅⴷⴷⵎ."
  },
  es: {
    heroTitle: "Da Vida a la Lengua",
    heroSubtitle: "Amazigh",
    heroDesc: "ⵜⵉⵏⴼⵓⵙⵉⵏ ⵏ ⵉⵎⵥⵥⵢⴰⵏⵏ transforma tus ideas en cuentos ilustrados escritos en Tifinagh. Un pont entre tradition et futur technologique.",
    startBtn: "Comenzar la Aventura",
    showcaseTitle: "Cuentos de la Comunidad",
    showcaseDesc: "Explora las últimas aventuras imaginadas por nos usuarios.",
    readOnlyTitle: "Modo Lectura",
    cultureTag: "IA al servicio de la cultura",
    featuresTitle: "Todo lo que puedes hacer",
    feat1Title: "IA Amazigh",
    feat1Desc: "Genera historias únicas en Tifinagh gracias a la inteligencia artificial.",
    feat2Title: "Ilustraciones",
    feat2Desc: "Cada página va acompañada de un dibujo mágico generado para tu cuento.",
    feat3Title: "Lectura de Audio",
    feat3Desc: "Escucha tus historias con una voz natural para aprender la pronunciación.",
    feat4Title: "Exportación PDF",
    feat4Desc: "Convierte tus creations en libros digitales para imprimir o compartir.",
    loginTitle: "¡Qué bueno verte de nuevo!",
    signupTitle: "Crea tu cuenta",
    authDesc: "",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre completo",
    loginBtn: "Iniciar sesión",
    signupBtn: "Registrarse",
    noAccount: "¿No tienes cuenta? Regístrate",
    hasAccount: "¿Ya tienes cuenta? Inicia sesión",
    library: "Biblioteca",
    explore: "Explorar",
    searchPlaceholder: "Buscar por título o contenido...",
    noResults: "No hay cuentos que coincidan con tu búsqueda.",
    prev: "Anterior",
    next: "Siguiente",
    profile: "Perfil",
    logout: "Cerrar sesión",
    saveProfile: "Guardar cambios",
    newStory: "Nueva Aventura",
    newStoryDesc: "Transforma tus sueños en cuentos amazighs.",
    storyPromptPlaceholder: "Un pequeño erizo que descubre las montagnes de l'Atlas...",
    genBtn: "Generar Historia",
    pages: "Páginas",
    lang: "Idioma de entrada",
    thinking: "Imaginando el cuento...",
    painting: "Creando illustrations...",
    quotaError: "L'API está muy ocupada. Prueba de nuevo en un minute.",
    emptyLib: "Tu biblioteca está vacía.",
    createFirst: "Crear mi primera historia",
    back: "Volver",
    share: "Compartir",
    download: "Descargar PDF",
    downloadAudio: "Descargar audio",
    close: "Cerrar",
    copy: "Copiado",
    vocabulary: "Vocabulario Mágico",
    audioError: "Servicio de voz no disponible."
  }
};
